import { useQuery } from '@tanstack/react-query';
import { baaKeys } from './queryKeys';
import { useGraphqlClient, clientGetBaaPersonForSelf } from '../graphql';

export const useBaaPersonForSelf = (firmID: undefined | null | string) => {
  const client = useGraphqlClient();

  const baaPersonForSelfQuery = useQuery({
    enabled: !!firmID,
    queryKey: baaKeys.baaPersonForSelf(firmID),
    queryFn: async () => {
      try {
        if (!firmID) return;
        return await clientGetBaaPersonForSelf(client, { firmID });
      } catch (error) {
        return null;
      }
    },
  });

  return {
    baaPersonForSelfQuery,
    baaPersonForSelf: baaPersonForSelfQuery.data,
  };
};
